import React, { PureComponent, Fragment } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import FilterListIcon from '@material-ui/icons/FilterList';

import styles from './styles';
import { IBookingProps } from './IBooking';
import locales from '../../locales';
import { TReserve } from '../../types/IBookingStore';
import { editableReserveStates } from '../../config/constants';
import ReserveList from '../../components/Booking/ReserveList';
import BookingDatePicker from '../../components/Booking/BookingDate';
import PageHeaderWrap from '../../components/Common/PageHeaderWrap';
import PageContentWrap from '../../components/Common/PageContentWrap';
import Reserve from '../../types/IAppReservesStore';
import CashBoxWarningCont from '../CashBoxWarning';
import { NoHostessWarning } from '../../features';
import FilterSortModal from '../../components/Booking/ReserveList/FilterSortModal';

interface IBookingState {
  filterModalOpen: boolean;
}

class Booking extends PureComponent<IBookingProps, IBookingState> {
  constructor(props: IBookingProps) {
    super(props);
    this.state = {
      filterModalOpen: false,
    };
  }

  componentDidMount(): void {
    const { isInit, initBookingPages } = this.props;

    if (!isInit) {
      initBookingPages();
    }
  }

  /** @description Ручка экшена для редактирования выбранного резерва */
  handleOpenEditReserveModal = (reserve: TReserve): void => {
    if (editableReserveStates.indexOf(reserve.state) !== -1) {
      const { addAppReserve } = this.props;
      addAppReserve(new Reserve('APP', reserve));
    }
  };

  /** @description Ручка для получения списка броней при редактирования текущей даты в списке резервов */
  handleChangeDate = (date: string): void => {
    const { getBookingList, currentRestaurant } = this.props;
    getBookingList(currentRestaurant, date);
  };

  /** @description Ручка для переключения фильтра */
  handleSwitchActives = (): void => {
    const { switchBookingFilter, onlyActive } = this.props;
    switchBookingFilter(!onlyActive, true);
  };

  /** @description Открытие модального окна фильтров */
  handleOpenFilterModal = (): void => {
    this.setState({ filterModalOpen: true });
  };

  /** @description Закрытие модального окна фильтров */
  handleCloseFilterModal = (): void => {
    this.setState({ filterModalOpen: false });
  };

  render() {
    const {
      classes,
      bookingInfoList,
      currentRestaurant,
      currentStatisticDate,
      filterBookingListBy,
      sortBookingList,
      onlyActive,
      filters,
      sort,
      addAppReserve,
    } = this.props;

    // Определяем, является ли устройство мобильным или планшетом
    const isClient = typeof window !== 'undefined';
    const isMobileOrTablet = isClient && window.innerWidth < 960;

    return (
      <Fragment>
        <PageHeaderWrap>
          <div className={classes.title}>
            <Typography variant="h6">
              {locales.t('booking.title')}
            </Typography>
          </div>

          {/* Спейсер слева от даты для центрирования на десктопе */}
          <div className={classes.spacerLeft} />

          <div className={classes.datePickerWrap}>
            <BookingDatePicker
              currentStatisticDate={currentStatisticDate}
              handleChangeDate={this.handleChangeDate}
            />
          </div>

          {/* Спейсер справа от даты для центрирования на десктопе */}
          <div className={classes.spacerRight} />

          <div className={classes.filter}>
            <Typography variant="caption">
              {locales.t('booking.onlyActive')}
            </Typography>
            <Switch
              checked={onlyActive}
              onChange={this.handleSwitchActives}
              color="primary"
            />
            {isMobileOrTablet && (
              <IconButton
                onClick={this.handleOpenFilterModal}
                aria-label="filter and sort"
                color="default"
              >
                <FilterListIcon />
              </IconButton>
            )}
          </div>
        </PageHeaderWrap>
        <CashBoxWarningCont />
        <NoHostessWarning />

        <PageContentWrap fullWidth>
          <Grid item xs={12}>
            <ReserveList
              bookingInfoList={bookingInfoList}
              filters={filters}
              sort={sort}
              handleOpenEditReserveModal={this.handleOpenEditReserveModal}
              handleSortBookingList={sortBookingList}
              handleFilterBy={filterBookingListBy}
            />
          </Grid>
        </PageContentWrap>

        <Fab
          className={classes.btnWrap}
          onClick={() => addAppReserve(new Reserve('APP'))}
          color="primary"
          disabled={!currentRestaurant}
        >
          <AddIcon />
        </Fab>

        {/* Модальное окно фильтров и сортировки для мобильных и планшетов */}
        {isMobileOrTablet && (
          <FilterSortModal
            open={this.state.filterModalOpen}
            onClose={this.handleCloseFilterModal}
            sort={sort}
            filters={filters}
            handleSortBookingList={sortBookingList}
            handleFilterBy={filterBookingListBy}
          />
        )}
      </Fragment>
    );
  }
}

const useStyles = makeStyles(styles as any);

const BookingWithStyles: React.FC<Omit<IBookingProps, 'classes'>> = (props) => {
  const classes = useStyles();
  return <Booking {...(props as any)} classes={classes} />;
};

export default BookingWithStyles;
